(function($) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      if ($('.free-product').length) {
         $('.custom-product-block').insertAfter('.product-single__meta .free-product')
      } else {
         $('.custom-product-block').insertAfter('.product-single__meta .text-with-icons__blocks')
      }
     

      $('.trust-icons').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        prevNextButtons: false,
        pageDots:true
      });
    }

    $('.collapsible-content__inner .jdgm-write-rev-link').on('click', function(){
      $(this).parents('.collapsible-content').css('height', 'auto');
    })
  
    $('.template-index .text-with-icons__blocks').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        prevNextButtons: false,
        pageDots:true
      });

  $('.hint-description').appendTo('body')
  
 $('.hint-block .hint').on({
    mouseenter: function () {
      var dataHint = $(this).data('hint');
      var mouseX = 0, mouseY = 0;
      var xp = 0, yp = 0;
     
        $(this).mousemove(function(e){
          mouseX = e.pageX ;
          mouseY = e.pageY ; 

         $('.hint-description').each(function(){
            if ($(this).data('hint-desc') == dataHint) {
              
               $(this).addClass('hint-hovered');
              if ($(this).hasClass('hint-hovered')) {
      
              
        
                $(this).css({
                top: mouseY + 20 +'px',
                left: mouseX - $(this).outerWidth() + 30 + 'px'
                })
                 var pos = $(this).position(),
                     posX = pos.left;
                

                if (posX < 0 || posX == 15 ) {
                  $(this).css('left', '15px');
               }
            } else {
                $(this).removeClass('hint-hovered');
              }
            }
          })
        });
      
      
    },
    mouseleave: function () {
      $('.hint-description').removeClass('hint-hovered');
    }
});


  
    $(document).ready(function() {


    $(".jdgm-preview-badge").click(function() {
      $(this).parents('.product-grid__container').find('.product-review-tab .collapsible-trigger').click()
    $([document.documentElement, document.body]).animate({
        scrollTop:  $(this).parents('.product-grid__container').find('.product-review-tab').offset().top - 150
    }, 500);
  });

      // if (window.matchMedia("(max-width: 767px)").matches) {
      //   if ($('.wishlist-hero-header-icon').length) {
      //     if ($('.wishlist-hero-header-icon').find('span').hasClass('wishlist-hero-items-count-exists')) {
      //       $('.wishlist-hero-header-icon').css('margin-right', '15px')
      //     }
      //   }
      // } else {
      //   if ($('.wishlist-hero-header-icon').length) {
      //     if ($('.wishlist-hero-header-icon').find('span').hasClass('wishlist-hero-items-count-exists')) {
      //       $('.wishlist-hero-header-icon').css('margin-right', '23px')
      //     }
      //   }
      // }

      
      
    });
})(jQuery);